import Element from "element-ui/lib/locale/lang/en";
import VeeValidate from "vee-validate/dist/locale/en";

import en from "./values/en-backup.json";

export default Object.assign(en, {
  el: Element.el,
  veevalidate: VeeValidate,
});



// WEBPACK FOOTER //
// ./src/lang/en.js